export default function GuaranteeSection() {
  return (
    <section className="py-20 bg-gradient-to-br from-[#FAF7F4] to-white">
      <div className="max-w-5xl mx-auto px-6">
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100">
          <div className="grid md:grid-cols-2 gap-0">
            {/* Partie gauche - Garantie */}
            <div className="bg-gradient-to-br from-[#3D2817] to-[#2C1810] p-10 flex flex-col justify-center relative overflow-hidden">
              {/* Motif de fond */}
              <div className="absolute inset-0 opacity-5">
                <div className="absolute top-0 right-0 w-64 h-64 bg-white rounded-full blur-3xl"></div>
                <div className="absolute bottom-0 left-0 w-64 h-64 bg-white rounded-full blur-3xl"></div>
              </div>

              <div className="relative z-10">
                {/* Badge */}
                <div className="inline-flex items-center gap-2 bg-[#E8956F]/20 px-4 py-2 rounded-full mb-6">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-shield-check-line text-[#E8956F] text-base"></i>
                  </div>
                  <span className="text-sm font-medium text-[#E8956F]">Garantie totale</span>
                </div>

                {/* Icône principale */}
                <div className="w-20 h-20 rounded-full bg-[#E8956F]/20 flex items-center justify-center mb-6">
                  <div className="w-10 h-10 flex items-center justify-center">
                    <i className="ri-shield-star-line text-[#E8956F] text-4xl"></i>
                  </div>
                </div>

                <h3 className="text-3xl md:text-4xl font-bold text-white mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
                  Garantie Satisfait ou Remboursé
                </h3>
                
                <div className="text-5xl font-bold text-[#E8956F] mb-6" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  30 jours
                </div>

                <p className="text-white/90 text-lg leading-relaxed">
                  Testez la formation en toute sérénité. Si elle ne répond pas à vos attentes, nous vous remboursons intégralement, sans question ni justification.
                </p>
              </div>
            </div>

            {/* Partie droite - Avantages */}
            <div className="p-10 flex flex-col justify-center">
              <h4 className="text-2xl font-bold text-[#3D2817] mb-8" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                Pourquoi cette garantie ?
              </h4>

              <div className="space-y-6">
                {[
                  {
                    icon: 'ri-heart-line',
                    title: 'Votre satisfaction avant tout',
                    description: 'Nous voulons que vous soyez pleinement convaincue de la valeur de cette formation.'
                  },
                  {
                    icon: 'ri-shield-check-line',
                    title: 'Zéro risque pour vous',
                    description: 'Vous pouvez explorer les premiers modules et décider en toute tranquillité.'
                  },
                  {
                    icon: 'ri-star-line',
                    title: 'Confiance en notre méthode',
                    description: 'Nous savons que notre approche fonctionne et transforme la vie des cavalières.'
                  },
                  {
                    icon: 'ri-time-line',
                    title: 'Remboursement rapide',
                    description: 'Un simple email suffit. Remboursement sous 7 jours ouvrés, sans complications.'
                  }
                ].map((item, index) => (
                  <div key={index} className="flex items-start gap-4">
                    <div className="w-12 h-12 rounded-xl bg-[#E8956F]/10 flex items-center justify-center flex-shrink-0">
                      <div className="w-6 h-6 flex items-center justify-center">
                        <i className={`${item.icon} text-[#E8956F] text-xl`}></i>
                      </div>
                    </div>
                    <div className="flex-1">
                      <h5 className="font-semibold text-[#3D2817] mb-1">{item.title}</h5>
                      <p className="text-sm text-gray-600 leading-relaxed">{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/* CTA */}
              <div className="mt-8 pt-8 border-t border-gray-200">
                <a 
                  href="https://sophrocavaliers.learnybox.com/formation-endometriose-cavalieres/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-3 px-10 py-5 bg-[#E8956F] text-white rounded-full text-lg font-semibold hover:bg-[#D67D5A] transition-all shadow-2xl hover:shadow-3xl hover:scale-105 whitespace-nowrap cursor-pointer"
                >
                  <span>Je m'inscris sans risque</span>
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-lg"></i>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Témoignage de confiance */}
        <div className="text-center mt-12">
          <p className="text-gray-600 text-sm">
            <strong className="text-[#3D2817]">98% de nos cavalières</strong> sont satisfaites et recommandent nos formations
          </p>
        </div>
      </div>
    </section>
  );
}
